<div *ngFor="let row of rows" class="cs-d-flex align-items-center w-100" [style.height.px]="params.rowHeight">
    <ng-container *ngFor="let column of params.columnApi.getColumnState()">
        <div *ngIf="!column.hide || show" [style.width.px]="column.width" style="padding: 0 10px;" class="w-100">
            <div class="ph-item height-100" [style.padding-left]="0" [style.padding-right]="0" [style.width]="'100%'">
                <div class="ph-col-12 w-100 height-100" [style.padding-left]="0" [style.padding-right]="0">
                    <div class="ph-row w-100">
                        <div class="ph-col-12 m-b--0 w-100"></div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>
